export const getControlStyles = () => ({
  root: {
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    top: -5,
    backgroundColor: 'rgba(0,0,0,0.75)',

    '& .ms-Button svg': {
      width: '100%',
    },
    '& .ms-Button:focus': {
      border: '1px solid #fff',
    },
    '& .ms-Button:hover': {
      backgroundColor: 'transparent',
    },
  },
  videoContainer: {
    paddingBottom: 32,
  },
  sliderContainer: {
    width: '100%',
  },
  previewVideo: {
    width: '100%',
    maxHeight: '100%',
  },
  container: {
    display: 'flex',
    alignItems: 'center',

    '& i': {
      width: '100%',
      cursor: 'pointer',
    },
  },
});

